/**
 * muiTheme
 * =========
 * Theme MUI derivado dos tokens da PhadaUI (src/ui/tokens.js).
 *
 * Motivo: antes o App usava `useTheme()`, que devolve o theme PADRÃO do MUI
 * (primary azul #1976d2). Por isso as páginas precisavam de overrides com
 * `!important` para forçar o roxo Phada em botões/inputs/etc.
 *
 * Com este theme, componentes MUI já nascem na identidade Phada (roxo #7B176E)
 * e os `!important` de marca deixam de ser necessários.
 *
 * Fonte única de cor/raio/tipografia: tokens.js — NÃO hardcode hex aqui.
 */

import { createTheme } from '@mui/material/styles';
import { COLORS, FONT, RADIUS } from './tokens';

const phadaMuiTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: COLORS.primary,
      dark: COLORS.primaryDark,
      light: COLORS.primaryGradientEnd,
      contrastText: COLORS.white,
    },
    secondary: {
      main: COLORS.info, // roxo médio
      contrastText: COLORS.white,
    },
    success: { main: COLORS.success, contrastText: COLORS.white },
    warning: { main: COLORS.warning, contrastText: COLORS.white },
    error: { main: COLORS.danger, contrastText: COLORS.white },
    info: { main: COLORS.info, contrastText: COLORS.white },
    text: {
      primary: COLORS.textPrimary,
      secondary: COLORS.textSecondary,
      disabled: COLORS.textMuted,
    },
    background: {
      default: COLORS.bg,
      paper: COLORS.bg,
    },
    divider: COLORS.border,
  },
  shape: {
    borderRadius: parseInt(RADIUS.md, 10), // 8px
  },
  typography: {
    fontFamily: FONT.family,
    button: { textTransform: 'none', fontWeight: FONT.weight.semibold },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', fontWeight: FONT.weight.semibold },
      },
    },
    // Menus e popovers NAO travam a rolagem da pagina.
    //
    // Por padrao o MUI trata todo Popover/Menu como modal e aplica scroll lock:
    // poe `overflow: hidden` no body e compensa a barra de rolagem que
    // desapareceu com `padding-right: 15px`. Efeito visivel: ao abrir o menu de
    // "Mais ações" da lista de Pedidos a barra de rolagem some e o conteudo
    // pula 15px para o lado; a pagina fica sem rolar enquanto o menu estiver
    // aberto (e continua travada se o menu nao completar a transicao de
    // fechamento). Um menu nao e um dialogo — nao ha razao para bloquear a
    // pagina atras dele.
    //
    // Vale para Select tambem, que renderiza um MuiMenu por baixo.
    // Dialogos (MuiDialog/MuiModal) seguem travando, o que ali e correto.
    MuiPopover: { defaultProps: { disableScrollLock: true } },
    MuiMenu: { defaultProps: { disableScrollLock: true } },
  },
});

export default phadaMuiTheme;
